import React, { ReactPortal } from "react"

interface TabProps{
    readonly title: string
}

interface IState{
    readonly index: number
}

export class Tabs extends React.Component<React.PropsWithChildren, IState>{
    constructor(props: React.PropsWithChildren){
        super(props)

        this.state = {
            index: 0
        }
    }

    getTabs = () => {
        const { children } = this.props,
        reactChildren = React.Children.toArray(children).filter((c: any) => c.type === Tab)

        return reactChildren as ReactPortal[]
    }

    render = () => {
        const tabs = this.getTabs(),
        { index } = this.state

        return <>
            <div className="navigation">
                {
                    tabs.map((tab, i) => <div className={"navigation-pill " + (index === i ? "selected" : "")} key={i} onClick={() => this.setState({ index: i })}>
                        {tab.props.title}
                    </div>)
                }
            </div>

            {tabs[index]?.props.children}
        </>
    }
}

export class Tab extends React.Component<React.PropsWithChildren<TabProps>>{}